export const enum WidgetFeature {
    /** @deprecated */
    InformationBanner = 'InformationBanner',
    FuzzySearch = 'FuzzySearch',
    MultiUploads = 'MultiUploads',
    WaitingGame = 'WaitingGame',
    WaitingGameHiScore = 'WaitingGameHiScore',
    WaitingGameEncryptedScore = 'WaitingGameEncryptedScore',
    EmptyHistoryScreen = 'EmptyHistoryScreen',
    Favorites = 'Favorites',
    AdAuth = 'AdAuth',
    FaviconIndicator = 'FaviconIndicator',
    BrowserNotifications = 'BrowserNotifications',
    MaximizeMinimize = 'MaximizeMinimize',
    LimitUnauthorizedFeatures = 'LimitUnauthorizedFeatures',
    HistoryDumpTxt = 'HistoryDumpTxt',
    HistoryDumpHtml = 'HistoryDumpHtml',
    ErrorScreen = 'ErrorScreen',
    ColorSchemes = 'ColorSchemes',
    BotReplyLoader = 'BotReplyLoader',
    MediaGallery = 'MediaGallery',
    CaptureOtp = 'CaptureOtp',
    PredictiveInput = 'PredictiveInput',
    VoiceRecorder = 'VoiceRecorder',
    VoiceGallery = 'VoiceGallery',
    SendFingerPrint = 'SendFingerPrint',
    DionVideo = 'DionVideo',
    PreventClosing = 'PreventClosing',
    OperatorWaitingTimer = 'OperatorWaitingTimer',
    WidgetTabs = 'WidgetTabs',
    IosGestures = 'IosGestures',
    PassPhraseListener = 'PassPhraseListener',
    LogToClipboard = 'LogToClipboard',
    LogToDiv = 'LogToDiv',
    UseHistoryAPI = 'UseHistoryAPI',
    QuickActionsMenuScrollAnimation = 'QuickActionsMenuScrollAnimation',
    ForceAstromAnalytics = 'ForceAstromAnalytics',
    ReconnectOnTimeout = 'reconnectOnTimeout',
}
